/**
 * TEAM API (REST). web-v2 deploy always sets:
 *   REACT_APP_TEAM_API_MODE=rest
 *   REACT_APP_TEAM_REST_URL=https://….execute-api….amazonaws.com
 */
export const restBaseUrl = (process.env.REACT_APP_TEAM_REST_URL || "")
  .trim()
  .replace(/\/$/, "");

export const apiMode = "rest";

/** Always true for web-v2; kept for call-site compatibility. */
export function isRestMode() {
  return true;
}
